import load from '#core/load';


const state = window.teal_state = window.teal_state || {};
state.font = state.font || {};

const material_symbols_name = '24px Material Symbols Outlined';
const material_symbols_$ = '.material-symbols'; // Sync with icon.scss
const loaded_c = 'loaded';


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('font')) return false;
		
		document.fonts.load(material_symbols_name).then(() => {
			document.querySelectorAll(material_symbols_$).forEach($icon => {
				$icon.addClass(loaded_c);
			});
		});
	},
	
};

export default module;
module.init();
